// extracted by mini-css-extract-plugin
export default {"DivButtons":"Pagination_DivButtons__ejMLY","Button":"Pagination_Button__SUKvp"};